export const TOKEN_TRANSFERS_KEYS = {
  title: 'tokenTransfers.title',
  empty: {
    noData: 'tokenTransfers.empty.noData',
  },
  errors: {
    loadFailed: 'tokenTransfers.errors.loadFailed',
  },
} as const;

export const TOKEN_TRANSFERS_ACTION_KEYS = {
  'export': 'tokenTransfers.actions.export',
  reset: 'tokenTransfers.actions.reset',
  copyToClipboard: 'tokenTransfers.actions.copyToClipboard',
  copied: 'tokenTransfers.actions.copied',
} as const;

export const TOKEN_TRANSFERS_EXPORT_KEYS = {
  title: 'tokenTransfers.export.title',
} as const;

export const TOKEN_TRANSFERS_FIELD_KEYS = {
  txnHash: 'tokenTransfers.fields.txnHash',
  dateTime: 'tokenTransfers.fields.dateTime',
  fromTo: 'tokenTransfers.fields.fromTo',
  from: 'tokenTransfers.fields.from',
  to: 'tokenTransfers.fields.to',
  status: 'tokenTransfers.fields.status',
  amount: 'tokenTransfers.fields.amount',
  tokenAddress: 'tokenTransfers.fields.tokenAddress',
  method: 'tokenTransfers.fields.method',
  valueUsd: 'tokenTransfers.fields.valueUsd',
  txnFee: 'tokenTransfers.fields.txnFee',
  txnFeeBot: 'tokenTransfers.fields.txnFeeBot',
} as const;

export const TOKEN_TRANSFERS_FILTER_KEYS = {
  search: 'tokenTransfers.filters.search',
} as const;

export const TOKEN_TRANSFERS_NOTICE_KEYS = {
  newTransfersOne: 'tokenTransfers.notice.newTransfersOne',
  newTransfersOther: 'tokenTransfers.notice.newTransfersOther',
  scanning: 'tokenTransfers.notice.scanning',
} as const;
